import { useQuery } from "@tanstack/react-query";
import { getAllPaalaegIndberetninger } from "@/api/paalaeg";
import type { PaalaegIndberetningOverviewModel } from "@/interfaces/paalaeg";

export const PAALAEGS_QUERY_KEY = ["cle-compliance", "paalaegs"] as const;

export const usePaalaegs = () =>
  useQuery<PaalaegIndberetningOverviewModel[]>({
    queryKey: PAALAEGS_QUERY_KEY,
    queryFn: getAllPaalaegIndberetninger,
    staleTime: 5 * 60 * 1000,
  });
